import React from "react";
import "./style.css";
import Drawer from 'material-ui/Drawer';
import { Link } from "react-router";
import Logo from '../../assets/images/notifyi-logo-light.png'
import LogoSolid from '../../assets/images/notifyi-logo-solid-light.png'

class StudentSideBar extends React.Component {

  state = {
    vWidth: null
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ vWidth: window.innerWidth });
  }

  render() {
    const {
      isOpen,
      handleRequestChange
    } = this.props

    const { vWidth } = this.state

    return (
      <Drawer
        className="dash-sidebar"
        open={isOpen}
        docked={vWidth >= 980 ? true : false}
        onRequestChange={(open) => handleRequestChange(open)}
      >
        <section className="dash-logo">
          <figure>
            <img src={LogoSolid} alt="logo" />
          </figure>
        </section>
        <Link className="dash-sidebar__item" to="/dashboard" activeClassName='active'>
          <i className="icon-grid dash-sidebar__icon" />
          Dashboard
        </Link>
        <Link className="dash-sidebar__item" to="/favourites" activeClassName="active">
          <i className="icon-heart dash-sidebar__icon" />
          My Favourites
        </Link>
        <Link className="dash-sidebar__item" to="/profile" activeClassName="active">
          <i className="icon-emotsmile dash-sidebar__icon" />
          My Profile
        </Link>
        <Link className={`dash-sidebar__item ${window.location.pathname === '/alertDetail' && 'active'}`} to="/AdmissionAlerts" activeClassName="active">
          <i className="icon-info dash-sidebar__icon" />
          Admission Alerts
        </Link>
        <Link className={`dash-sidebar__item ${window.location.pathname === '/scholarshipDetail' && 'active'}`} to="/scholarship" activeClassName="active">
          <i className="icon-badge dash-sidebar__icon" />
          Scholarship Alerts
        </Link>
        <Link className={`dash-sidebar__item ${window.location.pathname === '/careerDetail' && 'active'}`} to="/careers" activeClassName="active">
          <i className="icon-eyeglass dash-sidebar__icon" />
          Careers
        </Link>
        <Link className="dash-sidebar__contact-link" to="/contact">
          Got query? Contact Us!
        </Link>
      </Drawer>
    )
  }
}

export default StudentSideBar;



/** WEBPACK FOOTER **
 ** ./src/components/StudentSideBar/index.js
 **/